import { useSearchParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { useApi } from "../lib/api";
import { AVAIL, eur, fmtDate, fmtLong, todayISO } from "../lib/format";

const HEADERS = ["#", "Tipologia", "Marca e modello", "Targa", "Revisione", "Assicurazione", "Bollo", "Costo/g", "Manut.", "Stato oggi", "Cantiere oggi", "Note"];
const cell = "border border-black px-1.5 py-1 align-top";

function VehicleRow({ v, i }) {
  return (
    <tr style={{ breakInside: "avoid" }} data-testid={`print-vehicle-${v.id}`}>
      <td className={cell}>{i + 1}</td><td className={cell}>{v.type}</td><td className={cell}>{v.brand} {v.model}</td>
      <td className={`${cell} font-mono`}>{v.plate}</td><td className={cell}>{fmtDate(v.revision_date)}</td>
      <td className={cell}>{fmtDate(v.insurance_date)}</td><td className={cell}>{fmtDate(v.tax_date)}</td>
      <td className={`${cell} text-right`}>{eur(v.daily_cost)}</td><td className={cell}>{v.maintenance ? "Sì" : "No"}</td>
      <td className={cell}>{AVAIL[v.availability.status]?.label}</td><td className={cell}>{v.availability.site_name || "—"}</td>
      <td className={cell}>{v.notes}</td>
    </tr>
  );
}

export default function PrintVehicles() {
  const [params] = useSearchParams();
  const { data } = useApi("/vehicles", { q: params.get("q") || "", type: params.get("type") || "", status: params.get("status") || "" });
  if (!data) return <div className="p-10 text-center">Caricamento…</div>;
  return (
    <div className="min-h-screen bg-white text-black print-page" style={{ backgroundImage: "none" }}>
      <style>{"@page { size: A4 landscape; margin: 10mm; }"}</style>
      <div className="no-print sticky top-0 bg-slate-900 text-white p-3 flex justify-between items-center">
        <span className="text-sm">Anteprima elenco mezzi — usa "Salva come PDF" nella finestra di stampa</span>
        <button onClick={() => window.print()} className="bg-amber-500 text-slate-950 font-bold px-4 py-2 rounded-md flex items-center gap-2" data-testid="print-vehicles-now-btn"><Printer className="h-4 w-4" />Stampa / PDF</button>
      </div>
      <div className="p-6" data-testid="print-vehicles-sheet">
        <div className="flex justify-between items-end border-b-2 border-black pb-3 mb-4">
          <div><div className="text-2xl font-extrabold font-heading">ELENCO MEZZI</div><div className="text-sm">CANTIERE MANAGER PRO · {data.items.length} mezzi</div></div>
          <div className="text-right text-sm capitalize">{fmtLong(todayISO())}</div>
        </div>
        <table className="w-full text-xs border-collapse">
          <thead><tr className="bg-gray-100">{HEADERS.map((h) => <th key={h} className={`${cell} text-left`}>{h}</th>)}</tr></thead>
          <tbody>{data.items.map((v, i) => <VehicleRow key={v.id} v={v} i={i} />)}</tbody>
        </table>
      </div>
    </div>
  );
}
